import { render, staticRenderFns } from "./DelegationDecisionView.vue?vue&type=template&id=7970c026&scoped=true&"
import script from "./DelegationDecisionView.vue?vue&type=script&lang=js&"
export * from "./DelegationDecisionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970c026",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7970c026')) {
      api.createRecord('7970c026', component.options)
    } else {
      api.reload('7970c026', component.options)
    }
    module.hot.accept("./DelegationDecisionView.vue?vue&type=template&id=7970c026&scoped=true&", function () {
      api.rerender('7970c026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation/DelegationDecisionView.vue"
export default component.exports